import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import FormInformation from "../../components/form-information";
import FormBody from "../../components/form-body";
import FormResponse from "../../components/form-response";

export default function FormLayout({ recaptchaSiteKey, ignoreCaptcha }) {
  const [formStatus, setFormStatus] = useState("idle");

  useEffect(() => {
    if (formStatus !== "idle") {
      window.scrollTo(0, 0);
    }
  }, [formStatus]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Réparation d&apos;un article</h1>
        {formStatus === "success" && (
          <FormResponse success heading="Merci pour votre demande">
            <p>Merci d&apos;avoir choisi de faire réparer votre article.</p>
            <p>
              Votre demande a été transmise avec succès à notre partenaire de
              réparation.
            </p>
            <h3>Et maintenant ?</h3>
            <p>
              Ce dernier va examiner votre demande et vous contactera
              directement via l&apos;adresse e-mail fournie afin de vous
              présenter les options de réparation possibles, les tarifs et la
              procédure à suivre.
            </p>
            <p>
              Gardez un œil sur votre boîte de réception pour connaître les
              dernières informations.
            </p>
          </FormResponse>
        )}
        {formStatus === "error" && (
          <FormResponse
            success={false}
            heading="Oups, un problème est survenu"
            message="Veuillez actualiser la page pour réessayer."
          ></FormResponse>
        )}
        {formStatus === "idle" && (
          <>
            <FormInformation />
            <FormBody
              recaptchaSiteKey={recaptchaSiteKey}
              setFormStatus={setFormStatus}
              ignoreCaptcha={ignoreCaptcha}
            ></FormBody>
          </>
        )}
      </div>
    </div>
  );
}

FormLayout.propTypes = {
  recaptchaSiteKey: PropTypes.string.isRequired,
  ignoreCaptcha: PropTypes.bool,
};

FormLayout.defaultProps = {
  ignoreCaptcha: false,
};
